export default "__VITE_ASSET__kA8W7e1D__"